import { useAuth0 } from "@auth0/auth0-react";
import AuthService from "Lib/API/Auth";
import { InputField, LabelField } from "components";
import InfoTooltip from "components/InfoTooltip";
import AlertDialog from 'components/Dialog/index';
import MyButton from "components/MyButton/index";
import Button from "components/button/Button";
import { useFormik } from "formik";
import React, { useState } from 'react';
import { Col, Row } from "react-bootstrap";
import { toastr } from "react-redux-toastr";
import { Link, useHistory } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import SettingHeader from '../../SettingHeader/settingHEader';
import "./index.scss";

const TaxId = ({ heading }) => {
  const { getAccessTokenSilently } = useAuth0();

  const orgDetails = localStorage.getItem("organization") !== undefined
    ? JSON.parse(localStorage.getItem("organization"))
    : [];

  const [canEdit, setCanEdit] = useState(false);
  const [openDisableAlert, setOpenDisableAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [orgTaxId, setOrgTaxId] = useState(orgDetails?.taxId || "");

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      taxId: orgTaxId || "",
    },

    onSubmit: async (values) => {
      setIsLoading(true);
      const token = await getAccessTokenSilently();
      const data = {
        org_Id: orgDetails?._id,
        taxId: values?.taxId.trim(),
      };
      try {
        const response = await AuthService.updateOrgSettings(orgDetails?._id, data, token);
        toastr.success("Tax ID updated successfully");
        setIsLoading(false);
        setCanEdit(false);
        setOrgTaxId(values?.taxId);
      } catch (error) {
        if (error?.data?.validation?.length) {
          const validationErrors = error.data.validation;
          const errorList = validationErrors.map((item) => {
            return item.message;
          });
          toastr.error("Validation Error",  errorList.join(", "));
        } else {
          toastr.error("Error", error?.data?.message ?? "Something went wrong");
        }
        setIsLoading(false);
      }
    },
  });

const handleCloseDialog = () => {
  setOpenDisableAlert(false);
};

return (
  <div className="w-100">
    <SettingHeader
      heading={heading}
      path={"/financial-setting/accounts-tax-id"}
      edit={false}
      addNew={false}
      parentHeading={"Financial"}
      alertOnEdit={false}
    />
    <div className="tax-id">

    <div className="profile-container">
      <div className="edit-profile-container ">
        <div className="profile-body finance-provider-info">
          <Row className="tax-header">
            <Col className="col-sm-6 ml-0">
              <div className="contact-info">Tax ID</div>
            </Col>
            <Col>
              {!canEdit && (
                <div className="mt-3 setting-actions">
                  <a style={{ color: "#2555EF" }} onClick={() => {
                    setCanEdit(true);
                  }}>
                    {
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-pencil-square"
                          viewBox="0 0 16 16"
                        >
                          <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                          <path
                            fill-rule="evenodd"
                            d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                          />
                        </svg>
                        <span> Edit</span>
                      </span>
                    }
                  </a>
                </div>
              )}
            </Col>
          </Row>
        </div>
      </div>
    </div>
    <div className="tax-main">
      <Row className="tax-content">
        <Col className="col-sm-6">
            <div className="tax-form">
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <LabelField title="Organization Tax ID" />
                <InfoTooltip text="Used on donation receipts and tax documents sent to donors, not just for internal reference." style={{ marginBottom: '8px' }} />
              </div>
              <InputField
                type="text"
                {...{
                  formik,
                  title: "none",
                  name: `taxId`,
                  placeholder: "Organization Tax ID",
                }}
                formStyle={{ marginBottom: 0 }}
                value={canEdit ? formik.values?.taxId : orgTaxId}
                style={{
                  backgroundColor: "#F3F6F9",
                }}
                disabled={!canEdit}
                handleChange={(e) => {
                  const { value } = e.target;
                  if(value.trim().length > 16) return;
                  formik.handleChange(e);
                }}
              />
              {canEdit && (
              <div className="tax-form-actions">
                <Button 
                  onClick={() => {
                    setOpenDisableAlert(true);
                  }} 
                  variant="primary-outline"
                  size="md"
                  style={{ minWidth: 80 }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    formik.handleSubmit();
                  }}
                  variant="primary"
                  size="md"
                  style={{ minWidth: 80 }}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <BeatLoader color="#fff" size={6} margin={1} />
                  ) : (
                    "Save"
                  )}
                </Button>
              </div>
            )}
            </div>
        </Col>
      </Row>
    </div>
    </div>
    <AlertDialog
      open={openDisableAlert}
      handleClose={handleCloseDialog}
      onDecline={() => {
        setOpenDisableAlert(false);
      }}
      onAccept={() => {
        setCanEdit(false);
        setOpenDisableAlert(false);
      }}
      title={"Are you sure?"}
      description={"Do you want to discard the changes you made?"}
    />
  </div>
)
}

export default TaxId